export default __webpack_public_path__ + "static/media/IMG_2559.35c2dd01.JPG";